import { dcAddressToTitleCase } from "./MARService";

export const filterSortSchools = (schools, gradeFilters, wardFilters, offeringSorts, inBoundaryOnly)=> {

    let schoolsTemp = [...schools];
    // console.log("gradeFilters:", gradeFilters);
    // console.log("wardFilters:", wardFilters);
    // console.log("offeringSorts:", offeringSorts);
    if (gradeFilters && gradeFilters.length > 0) {
        gradeFilters.forEach(grade => {
            schoolsTemp = schoolsTemp.filter((school)=>{
                return school.properties.grades_served.includes(grade);
            });
        });
    }

    if (wardFilters && wardFilters.length > 0){
        schoolsTemp = schoolsTemp.filter(school => {
            let met = false;
            wardFilters.every(ward => {
                if (school.properties.addressInfo.ward.includes(parseInt(ward))) {
                    met = true;
                    return false;
                }
                return true;
            });
            return met === true;
        });
    }

    if (offeringSorts && offeringSorts.length > 0){
        schoolsTemp.forEach(school => {
            let offeringMetItems = [];
            let metCnt = 0;                
            offeringSorts.forEach(offering => {
                offeringMetItems.push({
                    label: offering.label,
                    met: school.properties.offerings.includes(offering.field)
                });
                if (school.properties.offerings.includes(offering.field)){
                    metCnt++;
                }
            });
            school.offeringMets={
                metCount: metCnt,
                metRatio: metCnt + " out of " + offeringSorts.length,
                offeringMetItems
            };
        });
    } else {
        schoolsTemp.forEach(school => {
            school.offeringMets=null;
        });            
    }

    if (inBoundaryOnly){
        schoolsTemp = schoolsTemp.filter(school => {
            return school.properties.inBoundary === true;
        })
    }

    schoolsTemp.sort((school1, school2)=>{
        // first sort by offerings met
        if (school1.offeringMets && school2.offeringMets){
            if (school1.offeringMets.metCount > school2.offeringMets.metCount) return -1;
            if (school1.offeringMets.metCount < school2.offeringMets.metCount) return 1;
        }

        // if distance search - sort that way - otherwise alphabetical
        if (school1.distance !== null && school2.distancee !== null){
            if (school1.distance >= school2.distance) return 1;
            if (school1.distance < school2.distance) return -1;
        } else {
            if (school1.properties.name > school2.properties.name) return 1;
            if (school1.properties.name < school2.properties.name) return -1;
        }

        return 0;

    });

    let rank = 1;
    schoolsTemp.forEach((element) => {
        if (element.rank.toString().indexOf('S') === -1) {
            element.rank = rank;
            rank++;
        }
    });    

    return schoolsTemp;

}


export const getResultOrderDesc = (schools, offeringSorts, searchedPlace, lang)=> {
    let langs = {
        en: {
            count: "schools found and",
            byalphabet: "listed alphabetically",
            byoffering: "listed by # of offerings met",
            bydistance: "listed by distance from"
        },
        es: {
            count: "escuelas encontradas y",
            byalphabet: "enumerados alfabéticamente",
            byoffering: "listado por # de ofertas satisfechas",
            bydistance: "enumerados por distancia desde"
        }
    };
    let count = schools.length + " " + langs[lang]["count"] + " ";
    if (schools.length===0) {
        return count;
    }
    let order = langs[lang]["byalphabet"];
    if (offeringSorts && offeringSorts.length > 0){
        order = langs[lang]["byoffering"];
    } else if (searchedPlace){
        let placename = searchedPlace.properties.FullAddress || searchedPlace.properties.Alias;
        order = langs[lang]["bydistance"] + " " + dcAddressToTitleCase(placename);
    }
    return count + order;
}

export const getFilterValues = (t, grades, wards, offeringSorts, searchedPlace)=> {
    let filterString = "";
    if (grades.length > 0) {
        let gradeTextArr = grades.map(item => {
            return item.toString().replace("_", "").toUpperCase();
        })
        filterString += t("filter.grade.title") + ": " + gradeTextArr.join(", ") + "<br/>";
    }
    if (wards.length > 0) {
        filterString += t("filter.ward.title") + ": " + wards.join(", ") + "<br/>";
    }
    if (offeringSorts.length > 0) {
        let offeringLabels = offeringSorts.map(item => {
            return item[t("filter.offering.field")]
        })
        filterString += t("filter.offering.title") + ": " + offeringLabels.join(", ");
    }
    // if (searchedPlace){
    //     let placename = searchedPlace.properties.FullAddress || searchedPlace.properties.Alias;
    //     order = langs[lang]["bydistance"] + " " + dcAddressToTitleCase(placename);
    // }
    return filterString;
}
